var map = {
	"./1/symbol_0.png": "63d8",
	"./1/symbol_1.png": "3c7a",
	"./1/symbol_10.png": "32e0",
	"./1/symbol_11.png": "a603",
	"./1/symbol_12.png": "af48",
	"./1/symbol_13.png": "5734",
	"./1/symbol_14.png": "9690",
	"./1/symbol_15.png": "19c9",
	"./1/symbol_16.png": "2e09",
	"./1/symbol_17.png": "3aa8",
	"./1/symbol_18.png": "e3c1",
	"./1/symbol_2.png": "17f5",
	"./1/symbol_3.png": "295b",
	"./1/symbol_4.png": "e004",
	"./1/symbol_5.png": "bf01",
	"./1/symbol_6.png": "9df8",
	"./1/symbol_7.png": "473c",
	"./1/symbol_8.png": "1df9",
	"./1/symbol_9.png": "3709"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f063";